// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function UserCircleGearIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m28.531 7.884-.582-.337a2.951 2.951 0 0 0 0-1.095l.582-.336a1 1 0 0 0-1-1.732l-.583.337c-.28-.24-.601-.425-.948-.548V3.5a1 1 0 1 0-2 0v.673a2.99 2.99 0 0 0-.948.548l-.583-.337a1 1 0 0 0-1 1.732l.582.337a2.947 2.947 0 0 0 0 1.095l-.582.336a1 1 0 1 0 1 1.732l.583-.337c.28.24.601.425.948.549v.672a1 1 0 0 0 2 0v-.672c.347-.124.668-.31.948-.55l.583.338a1 1 0 1 0 1-1.733ZM24 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm3.669 6.014a1 1 0 0 0-.822 1.151c.102.606.153 1.22.153 1.835a10.953 10.953 0 0 1-2.78 7.301 9.957 9.957 0 0 0-4.508-3.593 6 6 0 1 0-7.425 0A9.958 9.958 0 0 0 7.78 23.3 11 11 0 0 1 17.835 5.153a1 1 0 0 0 .33-1.973A12.99 12.99 0 1 0 28.82 13.835a1 1 0 0 0-1.151-.821ZM12 15a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-2.74 9.688a8 8 0 0 1 13.48 0 10.979 10.979 0 0 1-13.48 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
